export default __webpack_public_path__ + "book_details-isbn10.434355e1.png";